import React, { useState } from 'react';
import PropTypes from 'prop-types';

const getPaymentStatusInfo = status => {
  switch (status) {
    case 1:
      return ['#D32F2F', 'UNPAID'];
    case 2:
      return ['orange', 'PENDING'];
    case 3:
      return ['#17C671', 'PAID'];
    default:
      return ['black', 'UNKNOWN'];
  }
};

const PaymentRow = props => {
  const [isOpen, setIsOpen] = useState(false);

  const { payment } = props;
  const [statusColor] = getPaymentStatusInfo(3);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  let style = { cursor: 'pointer' };
  if (isOpen) {
    style = { ...style, borderBottom: 'none' };
  }

  return (
    <>
      <tr onClick={toggleOpen} style={style} className="hoverable">
        <td>{props.index + 1}</td>
        <td>{payment.date}</td>
        <td>
          <p className="is-bold">{payment.total} €</p>
        </td>
        <td>
          <div className="payment-status-icon" style={{ background: statusColor }} />
        </td>
        <td>
          {!isOpen && <img src="/img/icons/caret-down.svg" />}
          {isOpen && <img src="/img/icons/caret-up.svg" />}
        </td>
      </tr>
      {isOpen && (
        <tr>
          <td colSpan="5">
            <p>Client Name: {payment.client.name}</p>
            <p>Client Address: {payment.client.address}</p>
            <table className="table is-small">
              <thead>
                <tr>
                  <th></th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Total</th>
                  <th>Rate</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {payment.items.map((item, itemIndex) => (
                  <tr key={itemIndex}>
                    <td>{itemIndex + 1}</td>
                    <td>{item.count}</td>
                    <td>{item.price}</td>
                    <td>{item.total}</td>
                    <td>{item.rate}</td>
                    <td>{item.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </td>
        </tr>
      )}
    </>
  );
};

PaymentRow.propTypes = {
  index: PropTypes.number.isRequired,
  payment: PropTypes.shape({
    date: PropTypes.string,
    total: PropTypes.number.isRequired,
    client: PropTypes.shape({
      name: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
    }).isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.number.isRequired,
        description: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        rate: PropTypes.number.isRequired,
      }),
    ),
  }).isRequired,
};

const PaymentsTabContentMobile = props => {
  return (
    <div className="m-payments-block">
      <p className="m-payments-block-title">Payments history</p>
      <table className="m-payment-table">
        <tbody>
          {props.payments.map((item, i) => {
            return <PaymentRow key={i} payment={item} index={i} />;
          })}
        </tbody>
      </table>
    </div>
  );
};

PaymentsTabContentMobile.propTypes = {
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      total: PropTypes.number.isRequired,
      client: PropTypes.shape({
        name: PropTypes.string.isRequired,
        address: PropTypes.string.isRequired,
      }).isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          count: PropTypes.number.isRequired,
          description: PropTypes.string.isRequired,
          price: PropTypes.number.isRequired,
          rate: PropTypes.number.isRequired,
        }),
      ),
    }),
  ).isRequired,
};

export default PaymentsTabContentMobile;
